import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { CardGrid } from 'foundations-components/transitional/components/CardGrid';
import Immutable from 'immutable';
import { isFulfilled } from 'marketplace-ui-common/requestStates/RequestStateUtils';
import { useMemo } from 'react';
import ResultCard from './ResultCard';
import { jsx as _jsx } from "react/jsx-runtime";
const ResultsGrid = ({
  onResultClick,
  referrer,
  requestState,
  resultProps,
  results,
  section
}) => {
  const renderedResults = useMemo(() => {
    const resultsArray = Immutable.Iterable.isIterable(results) ? results.toArray() : results.slice(0);
    return resultsArray.map((result, index) => {
      return /*#__PURE__*/_jsx(ResultCard, Object.assign({}, resultProps, {
        onClick: () => {
          onResultClick(result, index, resultsArray.length, section);
        },
        referrer: referrer,
        result: result
      }), result.id);
    });
  }, [onResultClick, referrer, resultProps, results, section]);
  if (!isFulfilled(requestState)) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      "data-selenium-id": "results-loading-spinner",
      grow: true,
      minHeight: 150,
      layout: "centered"
    });
  }
  return /*#__PURE__*/_jsx(CardGrid, {
    columnSize: 300,
    gutterSize: 16,
    children: renderedResults
  });
};
export default ResultsGrid;